module.exports = ($node) => {
  $node.on('mousemove', function (event) {
    // console.log(event);
    const $t = $(this);
    const isMouseDown = $t.attr('data-mouse-down') === 'true';
    if (isMouseDown) {
      const mouseDownX = $t.attr('data-mouse-down-x') * 1;
      // const mouseDownY = $t.attr('data-mouse-down-y') * 1;
      if (mouseDownX) {
        if (mouseDownX - event.pageX > 20) {
          $t.trigger('mouseLeftMove')
            .attr('data-mouse-down-x', `${event.pageX}`)
            .attr('data-mouse-down-y', `${event.pageY}`);
        } else if (event.pageX - mouseDownX > 20) {
          $t.trigger('mouseRightMove')
            .attr('data-mouse-down-x', `${event.pageX}`)
            .attr('data-mouse-down-y', `${event.pageY}`);
        }
      }
    }
  }).on('mousedown', function (event) {
    $(this)
      .attr('data-mouse-down', 'true')
      .attr('data-mouse-down-x', `${event.pageX}`)
      .attr('data-mouse-down-y', `${event.pageY}`);
  }).on('mouseup mouseleave', function () {
    $(this)
      .attr('data-mouse-down', 'false')
      .attr('data-mouse-down-x', '0')
      .attr('data-mouse-down-y', '0');
  });
};
